function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useMemo, useState, createElement as _createElement } from 'react';
import { makeStyles, MenuList } from '@material-ui/core';
import { getTestIds } from "../../utils/TestIds";
import { useStateInRef } from "../../utils/useStateInRef";
import { Badge } from "../Badge";
import { CircularLoader } from "../CircularLoader";
import { Row } from "../Layout";
import { MenuItem } from "../MenuItem";
import { Searchbox } from "../Searchbox";
import { Typography } from "../Typography";
import styles from "./Menu.module.scss";
import { MenuContextualAction } from "./MenuContextualAction";
import { MenuPromotionalAction } from "./MenuPromotionalAction/MenuPromotionalAction";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useMenuListStyles = makeStyles({
  root: {
    paddingTop: 4,
    flex: 1,
    overflow: 'auto',
    outline: 'none'
  }
});
export const GetMenuTID = parentTestId => getTestIds(parentTestId);
export function Menu(props) {
  const {
    testId,
    loading,
    searchProps,
    footer,
    items,
    emptyText,
    dimensions
  } = props;
  const menuListClasses = useMenuListStyles();
  const footerItems = (footer === null || footer === void 0 ? void 0 : footer.items) || [];
  const {
    showSearch,
    strategy,
    autoFocus
  } = searchProps || {};
  const {
    height = 'auto',
    width = 400,
    minHeight = 80,
    maxHeight = 500
  } = dimensions || {};
  const {
    MenuTID
  } = useMemo(() => GetMenuTID(testId), [testId]);
  const [search, setSearch] = useState('');
  const getStrategy = useStateInRef(strategy);
  const [autoFocusItem, setAutoFocusItem] = useState(false);
  useEffect(() => {
    if (autoFocusItem) {
      setAutoFocusItem(false);
    }
  }, [autoFocusItem]);
  const filteredItems = useMemo(() => {
    const strategy = getStrategy();
    if (!showSearch || !strategy) {
      return items;
    }
    switch (strategy.type) {
      case 'text':
        {
          const trimmedSearch = search.trim().toLowerCase();
          return items.filter(item => {
            if (typeof item.text !== 'string') {
              return false;
            }
            return item.text.toLowerCase().includes(trimmedSearch);
          });
        }
      case 'custom':
        return items.filter(item => strategy.filterItem(search, item));
    }
  }, [items, showSearch, search]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    "data-testid": MenuTID.Root(),
    style: {
      height,
      width,
      minHeight,
      maxHeight
    },
    children: [showSearch && /*#__PURE__*/_jsx("div", {
      className: styles.searchSection,
      children: /*#__PURE__*/_jsx(Searchbox, {
        variant: "textfield",
        fluidWidth: true,
        autoFocus: autoFocus,
        "data-testid": MenuTID.Search(),
        value: search,
        onChange: e => setSearch(e.target.value),
        onClear: () => setSearch(''),
        onKeyDown: e => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            setAutoFocusItem(true);
          }
        }
      })
    }), /*#__PURE__*/_jsx(MenuList, {
      disablePadding: true,
      autoFocusItem: autoFocusItem,
      classes: menuListClasses,
      children: loading ? /*#__PURE__*/_jsx("li", {
        className: styles.loading,
        children: /*#__PURE__*/_jsx(CircularLoader, {
          "data-testid": MenuTID.Loading()
        })
      }) : filteredItems.length > 0 ? filteredItems.map((item, index) => /*#__PURE__*/_jsxs(MenuItem, {
        variant: "multiline",
        "data-testid": MenuTID.Item(index),
        className: styles.item,
        onClick: item.onClick,
        children: [/*#__PURE__*/_jsxs(Row, {
          gap: 4,
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            weight: "normal",
            skin: "secondary",
            className: styles.changeTextColorOnHover,
            "data-testid": MenuTID.ItemText(index),
            children: item.text
          }), item.badge && /*#__PURE__*/_jsx(Badge, {
            outlined: true,
            rounded: true,
            skin: "primary",
            "data-testid": MenuTID.ItemBadge(index),
            children: item.badge.text
          })]
        }), /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          className: styles.changeTextColorOnHover,
          "data-testid": MenuTID.ItemSubtext(index),
          children: item.subtext
        })]
      }, item.id)) : /*#__PURE__*/_jsx(MenuItem, {
        disabled: true,
        className: styles.emptyText,
        "data-testid": MenuTID.Empty(),
        children: emptyText
      })
    }), footerItems.length > 0 && /*#__PURE__*/_jsx("div", {
      children: footerItems.map((item, index) => {
        switch (item.variant) {
          case 'contextualAction':
            return /*#__PURE__*/_createElement(MenuContextualAction, _objectSpread(_objectSpread({}, item.props), {}, {
              key: index
            }));
          case 'promotionalAction':
            return /*#__PURE__*/_createElement(MenuPromotionalAction, _objectSpread(_objectSpread({}, item.props), {}, {
              key: index
            }));
        }
      })
    })]
  });
}